import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/** Search text and page of an equipment list, kept in the URL (?q=&page=). */
export function useEquipmentListParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const search = searchParams.get("q") || "";
  const page = Number(searchParams.get("page") || "1");

  const updateParams = useCallback(
    (updates: Record<string, string | null>) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          for (const [key, value] of Object.entries(updates)) {
            if (value === null) {
              next.delete(key);
            } else {
              next.set(key, value);
            }
          }
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  const setSearch = useCallback(
    (value: string) => updateParams({ q: value || null, page: null }),
    [updateParams],
  );

  const setPage = useCallback(
    (value: number) => updateParams({ page: value > 1 ? String(value) : null }),
    [updateParams],
  );

  return { search, page, setSearch, setPage };
}
